<template>
    <transition name="slide-fade">
        <div class="modal" :class="{'open' : open}" v-if="open">
            <div class="modal-content">
                <div class="bg-white w-full content-wrapper p-3">
                    <div class="absolute right-6 top-16 cursor-pointer" @click="clickCancel()">
                        <img class="w-4" src="@/assets/icon/ic-close.png" />
                    </div>
                    <div class="text-tc-blue-1 text-center text-24 font-medium pt-3 pb-4">{{lbl.shipping.title}}</div>
                    <FormDeliveryAddress ref="form-delivery-address"></FormDeliveryAddress>
                    <div class="mx-5 py-6">
                        <BlueBtn @click="clickOk()">{{lbl.shipping.confirm_btn}}</BlueBtn>
                    </div>
                </div>
            </div>
        </div>
    </transition>

    <transition name="fade">
        <div class="modal-backdrop" v-if="open"></div>
    </transition>
</template>
<script>
// import Util from "@/helper/Utility.js";
import LocaleMixin from "@/mixin/LocaleMixin.js";
//component
import FormDeliveryAddress from "@/module/Address/DeliveryAddress/component/FormDeliveryAddress.vue";
//service
import BzbsAddressList from "@/core/Address/service/BzbsAddressList.js";
import BlueBtn from '@/components/Button/BlueBtn.vue';
export default {
    name: "AddAddressModal",
    mixins: [LocaleMixin],
    components: {
        FormDeliveryAddress,
        BlueBtn
    },
    props: {
        controller: Object,
    },
    data: function() {
        return {
            open: false,
            busModal: null,
        };
    },
    created: function() {
        this.busModal = this.controller.busModal;
    },
    mounted: function() {
        this.busModal.on('show', this.show);
        this.busModal.on('hide', this.hide);
    },
    methods: {
        show: function() {
            document.body.classList.add('not-scroll');
            this.open = true;

            this.$nextTick(() => {
                this.$refs['form-delivery-address'].clearForm();
            });
        },
        hide: function() {
            document.body.classList.remove('not-scroll');
            this.open = false;
        },
        clickCancel: function() {
            this.hide();
            this.controller.sendCallbackCancel();
        },
        clickOk: function () {
            this.saveAddress();
        },

        saveAddress: function() {
            let formData = this.$refs['form-delivery-address'].submitForm();
            if (formData != null) {
                let params = formData.getParams();
                this.saveAddressApi(params);
            }
        },
        saveAddressApi: function(params) {
            this.hide();
            this.controller.loadingModal.show();

            BzbsAddressList.apiAddAddress(params).subscribe(() => {
                this.controller.loadingModal.hide();
                this.controller.sendCallbackAddSuccess(params);
            }, (err) => {
                this.controller.loadingModal.hide();
                console.log(err);

                let msg = err.message;
                this.controller.alertModal.clearModal()
                        .setMsg(msg)
                        .show();
                this.controller.alertModal.onClickOk(() => {
                    this.show();
                });
            });
        },
    },
}
</script>
<style lang="scss" scoped>
    @import "@/style/base/base.scss";
    @import "@/style/modal.scss";

    .modal {
        @extend %modal;
        overflow: unset;

        @include mobile {
            top: auto;
        }
        .modal-content {
            width: 400px;
            .content-wrapper {
                border-radius: 25px;
                @include mobile {
                    border-bottom-left-radius: 0px;
                    border-bottom-right-radius: 0px;
                    width: 100%;
                }
            }
            @include mobile {
                width: 100%;
                padding-top: 40px;
            }
        }
    }
</style>
